<template>
    <div>
        <div>
            <div class="row">
                <div class="col-12">
                    <strong>Title</strong>
                    <input type="text" v-model="host.title" class="form-control">
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-2">
                    <strong>URL</strong>
                    <input type="text" v-model="host.url" class="form-control">
                </div>
            </div>
            <div class="mt-3">
                <button type="submit" class="btn btn-info btn-fill text-light" @click.prevent="createHost">
                {{ title }}
                </button>
            </div>
        </div>
    </div>

</template>
<script>
  export default {
    props: {
      host_id : Number
    },
    components: {
    },
    data () {
      return {
        title : 'Create',
        host: {
          title: '',
          url: ''
        }
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      createHost () {
        const me = this;
        me.host.url = me.host.url.replace(/(^\w+:|^)\/\//, '');

        var method = 'post';
        var host = this.$server + 'organisation/'+ me.$route.params.org_id  +'/project/' + me.$route.params.prod_id + '/host';

        if (this.host_id != 0) {
          method = 'put';
          host = this.$server + 'organisation/'+ me.$route.params.org_id  +'/project/' + me.$route.params.prod_id + '/host/' + this.host_id;
        }

        this.$axios({ method, url: host, data: this.host })
        .then(res => {
          var r = res.data;
          if (r.success) {
            this.$swal({
                title: r.message
            });
            me.$emit("callback", true);
          }
        });
      },
      init() {
        if (this.host_id != 0) {
          this.title = 'Update';
          const me = this;
          this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + '/host/' + this.host_id)
          .then(res => {
            var r = res.data;
            if (r.success) {
              me.host = r.data[0];
            }
          });

        }
        this.$emit("callback", this.title);
      }
    }
  }

</script>
<style>

</style>
